import React, { useEffect, useState } from "react";
import axios from "axios";
import { Constants } from "../../CommonMethhods/Constants";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import { toast } from "react-toastify";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { useRef } from "react";
import moment from "moment";
import {
  AESEncryption,
  ApiResDecrypt,
  compareDate,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import SingleHoldingTable from "../../Components/ReportTables/SingleHoldingSidebarTable";
import { useDebounce } from "../../Components/useDebounce";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";

function SingleHoldingReport() {
  const storeToken = localStorage.getItem("ssoToken");
  const inpuRef = useRef("");
  const [inputIsIn, setInputIsIn] = useState("");
  const [countScriptName, setCountScriptName] = useState();
  const [assetType, setAssetType] = useState("eq");
  const [clientShow, setClientShow] = useState(false);
  const [optionVal, setOptionVal] = useState([]);
  const [pageScripCode, setPageScripCode] = useState(1);
  const [onDate, setOnDate] = useState("");
  const [checkDate, setCheckDate] = useState(false);
  const [isInOnClick, setIsInOnClick] = useState("");
  const [countScriptWiseHolding, setCountScriptWiseHolding] = useState();
  const [noPage, setNoPage] = useState(1);
  const [scriptData, setScriptData] = useState([]);
  const [scrollLoaderScriptData, setScrollLoaderScriptData] = useState(false);
  const [scrollLoaderHolding, setScrollLoaderHolding] = useState(false);
  const [errorScripHolding, setErrorScripHolding] = useState(false);
  const [mainLoader, setMainLoader] = useState(false);
  const [searchLoader, setSearchLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [scripNameError, setScripNameError] = useState(false);

  const debouncedValue = useDebounce(inputIsIn, 1000);
  useEffect(() => {
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  const getScriptNameData = async (pageNo = 1, searchKeyWord = "") => {
    if (pageNo === 1) {
      setSearchLoader(true);
      setScrollLoaderScriptData(false);
    }
    let payloadValue = {
      seg: assetType,
      pageNo: pageNo,
      pageSize: 10,
      search: searchKeyWord,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getApiDetails = await axios.post(
        Dashboard_Client_Report.Single_Holding_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getApiDetails?.data);
      if (res?.status === 0) {
        setCountScriptName(res?.data?.totalcount);
        if (pageScripCode > 1) {
          setOptionVal((prev) => {
            return [...prev, ...res?.data?.scipt];
          });
        } else {
          setOptionVal(res?.data?.scipt);
        }
      } else {
        setScripNameError(true);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    } finally {
      setSearchLoader(false);
      setScrollLoaderScriptData(false);
    }
  };

  function onSelect(e) {
    if (e.target.value) {
      setAssetType(e.target.value);
      setOptionVal([]);
      setIsInOnClick("");
      setPageScripCode(1);
      inpuRef.current.value = "";
      setInputIsIn("");
      setScriptData([]);
      setErrorScripHolding(false);
    }
  }

  useEffect(() => {
    if (inputIsIn === "") {
      getScriptNameData(1, inputIsIn);
    }
  }, [assetType, inputIsIn]);

  useEffect(() => {
    if (pageScripCode > 1) {
      getScriptNameData(pageScripCode, inputIsIn);
    }
  }, [pageScripCode]);

  const handleDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setOnDate(d);
    setCheckDate(false);
    setScriptData([]);
  };

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }
  if (onDate === "") {
    const current = new Date();
    const date = `${
      current.getMonth() + 1
    }-${current.getDate()}-${current.getFullYear()}`;
    const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");

    setOnDate(date1);
  }

  const getScriptWiseHolding = async (fileType, pageNumber, pageSize) => {
    if (pageNumber === 1 && fileType === "grid") {
      setMainLoader(true);
    }
    if (fileType === "excel") {
      setSmallLoaderExcel(true);
    }
    if (fileType === "pdf") {
      setSmallLoaderPdf(true);
    }
    if (fileType === "mail") {
      setSmallLoaderMail(true);
    }
    let payloadValue = {
      type: fileType,
      isin: isInOnClick,
      holdingDate: onDate,
      pageNo: pageNumber,
      pageSize: pageSize,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getScriptData = await axios.post(
        Dashboard_Client_Report.Script_Wise_Holidng,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getScriptData?.data);

      if (response?.status === 0) {
        setCountScriptWiseHolding(response?.data?.totalcount);
        if (fileType === "grid") {
          if (noPage > 1) {
            setScriptData((prev) => {
              return [...prev, ...response?.data?.singleholding];
            });
          } else {
            setScriptData(response?.data?.singleholding);
          }
        } else if (fileType === "excel") {
          window.open(response?.data, "_self", "noopener,noreferrer");
        } else if (fileType === "pdf") {
          window.open(response?.data, "_blank", "noopener,noreferrer");
        } else if (fileType === "mail") {
          toast.success("Mail sent successfully");
        }
      } else {
        setScriptData([]);
        if (fileType === "grid") {
          setErrorScripHolding(response?.message);
        } else {
          toast.error(response?.message);
        }
      }
    } catch (error) {
      toast.error(error.message);
      console.log(error);
      toast.error(error.message);
      setScriptData([]);
    } finally {
      setMainLoader(false);
      setScrollLoaderHolding(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    }
  };
  useEffect(() => {
    if (isInOnClick) {
      getScriptWiseHolding("grid", noPage, 10);
    }
  }, [noPage]);

  const handleScrollScript = async (e) => {
    const a = e.target;
    if (
      a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight &&
      !scrollLoaderHolding
    ) {
      if (!(countScriptWiseHolding <= noPage * 10)) {
        setNoPage((prev) => prev + 1);
        setScrollLoaderHolding(true);
      }
    }
  };

  const handleOnClick = (e) => {
    if (onDate.length) {
      if (e.target.value) {
        if (isInOnClick) {
          if (compareDate(onDate)) {
            if (e.target.value === "grid") {
              getScriptWiseHolding(e.target.value, 1, 10);
            } else {
              getScriptWiseHolding(e.target.value, 1, -1);
            }
          } else {
            setCheckDate("Please Select Correct Date");
          }
        } else {
          toast.error("Please select valid ISIN");
        }
      }
    } else {
    }
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  //for dropdown
  const handleScroll = async (e) => {
    const a = e.target;
    if (
      a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight &&
      !scrollLoaderScriptData
    ) {
      if (!(countScriptName <= 10 * pageScripCode)) {
        setPageScripCode((prev) => prev + 1);
        setScrollLoaderScriptData(true);
      }
    }
  };
  //end dropdown

  function handleClientName(data) {
    if (data) {
      setOptionVal([]);
      setIsInOnClick("");
      setClientShow(true);
      setScriptData([]);
      setErrorScripHolding(false);
      setPageScripCode(1);
      getScriptNameData(1, data);
    }
  }

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports singlesidebar">
        <div className="card-box">
          <h2 className="report-title">{Constants.Single_Holding_Report}</h2>
          <div className="row input-field-wrapper">
            <div className="col-md-4 col-sm-4 col-12">
              <div className="form-group">
                <label className="form-label">{Constants.Asset_Type}</label>
                <select onChange={onSelect}>
                  <option value="eq">{Constants.Equity}</option>
                  <option value="fno">FNO</option>
                </select>
              </div>
            </div>

            <div className="col-md-4 col-sm-4 col-12">
              <div className="form-group">
                <label className="form-label">
                  {Constants.Script_Scheme_Instrument}
                </label>
                <div className="rm-custom-dropdown">
                  <input
                    type="text"
                    name="search-text"
                    // value={isInOnClick}
                    ref={inpuRef}
                    className="input-st"
                    placeholder="Search by Name/Code..."
                    autoComplete="off"
                    onChange={(e) => {
                      e.target.value = e.target.value.toUpperCase();
                      setInputIsIn(e.target.value);
                      setScriptData([]);
                      setNoPage(1);
                    }}
                  />

                  <button
                    className="rm-dropdown-btn"
                    onClick={() => setClientShow(!clientShow)}
                  >
                    <span className="icon-right-arrow-triangle"></span>
                  </button>

                  {clientShow && (
                    <>
                      <ul
                        className="rm-mapping-ap border-0"
                        onScroll={(e) => handleScroll(e)}
                      >
                        {searchLoader ? (
                          <div className="loader-center">
                            <LoaderForSearch />
                          </div>
                        ) : optionVal && optionVal.length > 0 ? (
                          optionVal.map((item, i) => (
                            <li
                              key={i}
                              onClick={() => {
                                setClientShow(false);
                                inpuRef.current.value = item.isin;
                                setIsInOnClick(item.isin);
                                setScriptData([]);
                                setOptionVal([]);
                              }}
                              className="rm-maping-item-wrapper"
                            >
                              <div> {item.isin}</div>
                              <div> {item.scripName}</div>
                            </li>
                          ))
                        ) : (
                          scripNameError && (
                            <li className="rm-maping-item-wrapper">
                              <h5>Script Name doesn't exist</h5>
                            </li>
                          )
                        )}

                        {scrollLoaderScriptData && pageScripCode > 1 && (
                          <div className="loader-center">
                            <LoaderForSearch />
                          </div>
                        )}
                      </ul>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-4 col-12">
              <div className="form-group calendar-icon">
                <label className="form-label">{Constants.As_On_Date}</label>
                <input
                  type="date"
                  placeholder="DD/MM/YYYY"
                  className="datepicker form-control"
                  max={DateReverse}
                  defaultValue={formatDate(onDate)}
                  onChange={handleDateChange}
                />
                <span className="to-date-error">{checkDate}</span>
                <span className="icon-calendar ico"></span>
              </div>
            </div>
          </div>
          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={(e) => {
                handleOnClick(e);
              }}
            >
              {Constants.Search}
            </button>
          </div>
          <div>
            <ReportTableHeader
              smallLoaderMail={smallLoaderMail}
              showEmailBtn={true}
              handleOnClick={handleOnClick}
              smallLoaderExcel={smallLoaderExcel}
              smallLoaderPdf={smallLoaderPdf}
            />
          </div>
          <div className="for-grid-section">
            {mainLoader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : scriptData && scriptData?.length > 0 ? (
              <>
                <div>
                  <SingleHoldingTable
                    scriptData={scriptData}
                    handleScrollScript={handleScrollScript}
                    scrollLoader={scrollLoaderHolding}
                  />
                </div>
              </>
            ) : (
              errorScripHolding && noDataFound(errorScripHolding)
            )}
          </div>
          {/* </div> */}
        </div>
      </main>
    </>
  );
}

export default SingleHoldingReport;
